import PropTypes from 'prop-types';

import LandingPageLink from 'components/landing/LandingPageLink';
import SmallProductCard from 'zen/components/common/SmallProductCard';
import css from 'styles/components/common/productGrid.scss';
import { makeComponentHeading } from 'helpers/LandingPageUtils';

const ProductGrid = ({ slotName, slotDetails, onLandingComponentClick, onProductClick }, { testId }) => {
  const { products, title, ctacopy, ctalink, gae } = slotDetails;
  const linkProps = {
    'onClick': onLandingComponentClick,
    'data-eventlabel': 'productGrid',
    'data-eventvalue': gae
  };

  return (
    <div className={css.productGrid} data-slot-id={slotName}>
      {makeComponentHeading({ heading: title })}
      <div className={css.productSection}>
        {products.slice(0, 8).map((product, i) => <SmallProductCard
          index={i}
          key={`${product.styleId}-${i}`}
          cardData={product}
          onClick={onProductClick}
          productClass={css.item} />)}
      </div>
      {ctalink &&
        <LandingPageLink url={ctalink} {...linkProps}>
          <div className={css.centerLink} data-test-id={testId('zenRecoCtaPill')}>
            <p className={css.ctaButton}>{ctacopy}</p>
          </div>
        </LandingPageLink>
      }
    </div>
  );
};

ProductGrid.contextTypes = {
  testId: PropTypes.func
};

export default ProductGrid;
